export default __webpack_public_path__ + "static/media/bg-top-right.4b4ceab9.svg";